import React, { useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'

export default function EventTicketModal({title, createEventModal, setCreateEventModal, eventTickets, setEventsTickets, selectedTicketId}) {
  const [ticketName, setTicketName] = useState('')
  const [ticketPrice, setTicketPrice] = useState('')
  const [ticketQuantity, setTicketQuantity] = useState('')
  const [unlimitedTicketsQuantity, setUnlimitedTicketsQuantity] = useState(false)
  const [ticketDescription, setTicketDescription] = useState('')

  const handleClose = () =>{
    setCreateEventModal(false);
  }
  
  const handleSaveClose = () => {
    let _eventTickets = [...eventTickets]
    if (selectedTicketId || selectedTicketId === 0) {
      _eventTickets[selectedTicketId].name = ticketName
      _eventTickets[selectedTicketId].price = parseFloat(ticketPrice)
      _eventTickets[selectedTicketId].quantity = parseInt(ticketQuantity)
      _eventTickets[selectedTicketId].description = ticketDescription
      _eventTickets[selectedTicketId].unlimitedTicketsQuantity = unlimitedTicketsQuantity

    } else {
      _eventTickets.push({
        name:ticketName,
        price: parseFloat(ticketPrice),
        quantity: parseInt(ticketQuantity),
        unlimitedTicketsQuantity: unlimitedTicketsQuantity,
        description: ticketDescription
      })
    }
    setEventsTickets(_eventTickets);
    setCreateEventModal(false);
    setTicketName('');
    setTicketPrice(null);
    setTicketQuantity(null);
    setUnlimitedTicketsQuantity(false);
  }

  useEffect(()=>{
    let _eventTickets = [...eventTickets]
    if (createEventModal === false) {
      setTicketName('')
      setTicketPrice('')
      setTicketQuantity('')
      setTicketDescription('')
      setUnlimitedTicketsQuantity(false)
    } else if (selectedTicketId !== false) {
      const selectedEvent = _eventTickets[selectedTicketId]
      setTicketName(selectedEvent.name)
      setTicketPrice(selectedEvent.price)
      setTicketQuantity(selectedEvent.quantity)
      setTicketDescription(selectedEvent.description)
      setUnlimitedTicketsQuantity(selectedEvent.unlimitedTicketsQuantity);
    }
  }, [eventTickets, createEventModal, selectedTicketId])

  return (
    <Modal show={createEventModal} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title>{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
    <Form>
      <Form.Group className="mb-3">
        <Form.Label>Ticket name</Form.Label>
        <Form.Control 
          type="text" 
          placeholder="Tier 1" 
          defaultValue={ticketName}
          onChange={(e)=>setTicketName(e.target.value)}
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Quantity</Form.Label>
        {!unlimitedTicketsQuantity && <Form.Control 
          type="number" 
          placeholder="100" 
          defaultValue={ticketQuantity}
          onChange={(e)=>setTicketQuantity(e.target.value)}
          required
        />}
        <Form.Check
          type='checkbox'
          label='Unlimited'
          checked={unlimitedTicketsQuantity}
          onChange={(e)=>{setUnlimitedTicketsQuantity(e.target.checked)}}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Price</Form.Label>
        <Form.Control 
          type="number" 
          placeholder="49.95" 
          defaultValue={ticketPrice}
          onChange={(e)=>setTicketPrice(e.target.value)}
          required
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Description</Form.Label>
        <Form.Control 
          as="textarea" 
          rows={3} 
          defaultValue={ticketDescription}
          onChange={(e)=>setTicketDescription(e.target.value)}
        />
      </Form.Group>
      </Form>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={handleSaveClose}>
        Save
      </Button>
    </Modal.Footer>
  </Modal>
  )
}
